import { jsx as i } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { DataDetailsModal as Te } from "../../../../internal/DataOverviewDisplay/DataDetailsModal.js";
import { TransactionsTable as Ae } from "../TransactionsTable/TransactionsTable.js";
import Se from "../../../../../hooks/useBalanceAccountSelection.js";
import Ee from "../../../../internal/FilterBar/filters/DateFilter/DateFilter.js";
import { FilterParam as t } from "../../../../types.js";
import Fe from "../../../../../hooks/useModalDetails/useModalDetails.js";
import Ne from "../../../../../core/Context/useCoreContext.js";
import { useCallback as c, useMemo as u, useState as v, useEffect as I } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { LIMIT_OPTIONS as Me, DEFAULT_PAGE_LIMIT as he } from "../../../../internal/Pagination/constants.js";
import Ie from "../TransactionTotals/TransactionTotals.js";
import { Balances as _e } from "../Balances/Balances.js";
import De from "../../../../../hooks/useDefaultOverviewFilterParams.js";
import Oe from "../../hooks/useTransactionsOverviewMultiSelectionFilters.js";
import { AmountFilter as Ue } from "../../../../internal/FilterBar/filters/AmountFilter/AmountFilter.js";
import { MAX_TRANSACTIONS_DATE_RANGE_MONTHS as ge, BASE_CLASS as be, SUMMARY_CLASS as Le, SUMMARY_ITEM_CLASS as X, BASE_CLASS_DETAILS as we } from "./constants.js";
import { useResponsiveViewport as xe, mediaQueries as Re } from "../../../../../hooks/useResponsiveViewport.js";
import { useCustomColumnsData as ye } from "../../../../../hooks/useCustomColumnsData.js";
/* empty css                          */
import Pe from "../../../../internal/Pagination/hooks/useCursorPaginatedRecords.js";
import { Header as ke } from "../../../../internal/Header/Header.js";
import { useFilterBarState as ve, FilterBarMobileSwitch as Xe, FilterBar as Ge } from "../../../../internal/FilterBar/FilterBar.js";
import Ye from "../../../../internal/FormFields/Select/BalanceAccountSelector/BalanceAccountSelector.js";
import G from "../MultiSelectionFilter/MultiSelectionFilter.js";
import { useConfigContext as je } from "../../../../../core/ConfigContext/context.js";
import { listFrom as p } from "../../../../../utils/collection/main.js";
import { isUndefined as Y, isFunction as ze } from "../../../../../utils/value/is.js";
import { EMPTY_OBJECT as He } from "../../../../../utils/value/constants.js";
const Ft = ({
  onFiltersChanged: T,
  balanceAccounts: _,
  allowLimitSelection: D,
  preferredLimit: j = he,
  onRecordSelection: O,
  showDetails: U,
  isLoadingBalanceAccount: z,
  onContactSupport: H,
  hideTitle: V,
  columns: W,
  onDataRetrieved: g
}) => {
  const { i18n: A } = Ne(), { getTransactions: S } = je().endpoints, { activeBalanceAccount: e, balanceAccountSelectionOptions: J, onBalanceAccountSelection: K } = Se(_), { defaultParams: d, nowTimestamp: E, refreshNowTimestamp: F } = De("transactions", e), Q = c(
    async ({ balanceAccount: o, ...r }, s) => S({ signal: s, errorLevel: "error" }, {
      query: {
        ...r,
        statuses: p(r[t.STATUSES]),
        categories: p(r[t.CATEGORIES]),
        currencies: p(r[t.CURRENCIES]),
        createdSince: r[t.CREATED_SINCE] ?? d.current.defaultFilterParams[t.CREATED_SINCE],
        createdUntil: r[t.CREATED_UNTIL] ?? d.current.defaultFilterParams[t.CREATED_UNTIL],
        sortDirection: "desc",
        balanceAccountId: (e == null ? void 0 : e.id) ?? "",
        minAmount: Y(r.minAmount) ? void 0 : parseFloat(r.minAmount),
        maxAmount: Y(r.maxAmount) ? void 0 : parseFloat(r.maxAmount)
      }
    }),
    [e == null ? void 0 : e.id, d, S]
  ), b = ve(), Z = u(() => ze(T) ? T : void 0, [T]), $ = u(() => D ? Me : void 0, [D]), { canResetFilters: B, error: q, fetching: ee, filters: n, limit: te, limitOptions: re, records: f, resetFilters: Ve, updateFilters: l, updateLimit: ie, ...oe } = Pe({
    fetchRecords: Q,
    dataField: "data",
    filterParams: d.current.defaultFilterParams,
    initialFiltersSameAsDefault: !0,
    onFiltersChanged: Z,
    preferredLimit: j,
    preferredLimitOptions: $,
    enabled: !!(e != null && e.id) && !!S
  }), [a, L] = v([]), [ne, se] = v(!1), le = c((o, r) => {
    L(o), se(r);
  }, []), { categoriesFilter: w, currenciesFilter: x, statusesFilter: N } = Oe(
    {
      filters: n,
      updateFilters: l
    },
    a
  );
  I(() => {
    L(void 0), l({
      [t.BALANCE_ACCOUNT]: e == null ? void 0 : e.id,
      [t.CURRENCIES]: void 0
    });
  }, [l, e == null ? void 0 : e.id]), I(() => {
    F();
  }, [n, F]), I(() => {
    N.updateSelection({ target: { value: "Booked", name: "status" } });
  }, [N]);
  const R = xe(Re.down.sm), ae = !!a && a.length > 1, y = u(
    () => ({
      showDetails: U ?? !0,
      callback: O
    }),
    [U, O]
  ), me = u(() => ({ transaction: y }), [y]), de = c(
    ({ records: o, retrievedData: r }) => o.map((s) => ({ ...r.find((C) => C.id === s.id), ...s })),
    []
  ), { customRecords: M, loadingCustomRecords: ce } = ye({ records: f, onDataRetrieved: g, mergeCustomData: de }), { updateDetails: P, resetDetails: ue, selectedDetail: fe } = Fe(me), k = c(
    ({ id: o }) => {
      const r = f.find((m) => m.id === o), s = M.find((m) => m.id === o);
      return r && s ? Object.keys(s).reduce((C, h) => (h in r || (C[h] = s[h]), C), {}) : null;
    },
    [f, M]
  ), Ce = c(
    ({ id: o }) => {
      P({
        selection: {
          type: "transaction",
          data: o,
          balanceAccount: e || "",
          extraDetails: k({ id: o }) ?? He
        },
        modalSize: "small"
      }).callback({ id: o });
    },
    [e, P, k]
  ), pe = u(() => {
    const o = new Date(E);
    return o.setMonth(o.getMonth() - ge), o.toString();
  }, [E]);
  return /* @__PURE__ */ i("div", { className: be, children: [
    /* @__PURE__ */ i(ke, { hideTitle: V, titleKey: "transactionsOverviewTitle", children: /* @__PURE__ */ i(Xe, { ...b }) }),
    /* @__PURE__ */ i(Ge, { ...b, children: [
      /* @__PURE__ */ i(
        Ye,
        {
          activeBalanceAccount: e,
          balanceAccountSelectionOptions: J,
          onBalanceAccountSelection: K
        }
      ),
      /* @__PURE__ */ i(
        Ee,
        {
          canResetFilters: B,
          defaultParams: d,
          filters: n,
          nowTimestamp: E,
          refreshNowTimestamp: F,
          sinceDate: pe,
          timezone: e == null ? void 0 : e.timeZone,
          updateFilters: l
        }
      ),
      /* @__PURE__ */ i(G, { ...w, placeholder: A.get("filterPlaceholder.category") }),
      /* @__PURE__ */ i(
        Ue,
        {
          availableCurrencies: a,
          selectedCurrencies: p(n[t.CURRENCIES]),
          name: "range",
          label: A.get("amount"),
          minAmount: n[t.MIN_AMOUNT],
          maxAmount: n[t.MAX_AMOUNT],
          updateFilters: l,
          onChange: l
        }
      ),
      /* @__PURE__ */ i(G, { ...x, placeholder: A.get("filterPlaceholder.currency") })
    ] }),
    /* @__PURE__ */ i("div", { className: Le, children: [
      /* @__PURE__ */ i("div", { className: X, children: /* @__PURE__ */ i(
        Ie,
        {
          availableCurrencies: a,
          isAvailableCurrenciesFetching: ne,
          balanceAccountId: e == null ? void 0 : e.id,
          statuses: N.selection,
          categories: w.selection,
          createdUntil: n[t.CREATED_UNTIL],
          createdSince: n[t.CREATED_SINCE],
          currencies: x.selection,
          minAmount: n[t.MIN_AMOUNT] ? parseFloat(n[t.MIN_AMOUNT]) : void 0,
          maxAmount: n[t.MAX_AMOUNT] ? parseFloat(n[t.MAX_AMOUNT]) : void 0,
          fullWidth: R
        }
      ) }),
      /* @__PURE__ */ i("div", { className: X, children: /* @__PURE__ */ i(
        _e,
        {
          balanceAccountId: e == null ? void 0 : e.id,
          onCurrenciesChange: le,
          defaultCurrencyCode: e == null ? void 0 : e.defaultCurrencyCode,
          fullWidth: R
        }
      ) })
    ] }),
    /* @__PURE__ */ i(
      Te,
      {
        selectedDetail: fe,
        resetDetails: ue,
        className: we,
        children: /* @__PURE__ */ i(
          Ae,
          {
            activeBalanceAccount: e,
            availableCurrencies: a,
            error: q,
            hasMultipleCurrencies: ae,
            limit: te,
            limitOptions: re,
            loading: ee || z || !_ || ce,
            onContactSupport: H,
            onLimitSelection: ie,
            onRowClick: Ce,
            showPagination: !0,
            transactions: g ? M : f,
            customColumns: W,
            ...oe
          }
        )
      }
    )
  ] });
};
export {
  Ft as TransactionsOverview
};
